import { useAuth } from "../context/AuthContext";

const UserCan = ({ children, perms }) => {
    const user = useAuth(); // Get user context
    const userPerms = user?.user?.perms || []; // Get user permissions safely

    // Check if all requested permissions are included in the user's permissions
    const allIncluded = perms.every(perm => userPerms.includes(perm));

    // If user has all required permissions, display children, otherwise return null
    return allIncluded ? children : null;
};

export default UserCan;
